import PropTypes from 'prop-types';
import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {setThousandSeparator} from '../../../util/utils';
import Label from '../BaseComponentWrappers/MotifLabel';

function CanvasFormInputDisplay({className, label, showLabel, value, isReadOnly, onClick, children, showPlainText}) {
	const userPreferences = useSelector((state) => state.userPreferences);
	const isAresView = useSelector((state) => state.isAresView);

	return (
		<>
			{isAresView ? (
				<StyledCanvasFormInputDisplay
					className="StyledCanvasFormInputDisplay"
					isReadOnly={isReadOnly}
					onClick={onClick}
				>
					{!value && (
						<Label title={label} className="canvas-form-input-display-label">
							{label}
						</Label>
					)}
					<div className={`canvas-form-input-display-value ${className}`} title={showPlainText && value}>
						{showPlainText
							? value
							: React.cloneElement(children, {value, ...setThousandSeparator(userPreferences.numberFormat)})}
					</div>
				</StyledCanvasFormInputDisplay>
			) : (
				<StyledCanvasFormInputDisplay
					className={`StyledCanvasFormInputDisplay ${className} ${isReadOnly ? 'isReadOnly' : ''}`}
					isReadOnly={isReadOnly}
					onClick={onClick}
				>
					{!value && <Label className="canvas-form-input-display-label">{label}</Label>}
					<div className="canvas-form-input-display-value">
						{React.cloneElement(children, {value, ...setThousandSeparator(userPreferences.numberFormat)})}
					</div>
				</StyledCanvasFormInputDisplay>
			)}
		</>
	);
}

CanvasFormInputDisplay.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string,
	showLabel: PropTypes.bool,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	isReadOnly: PropTypes.bool,
	onClick: PropTypes.func
};

CanvasFormInputDisplay.defaultProps = {
	className: 'canvas-form-input-display',
	showLabel: false,
	isReadOnly: false
};

export default CanvasFormInputDisplay;

const StyledCanvasFormInputDisplay = styled.section`
	display: flex;
	flex-flow: column;
	padding: var(--px-8) var(--px-6) !important;
	border: var(--px-1) solid var(--neutrals-300);
	background-color: var(--neutrals-00white);
	font-size: var(--px-14) !important;
	border-radius: var(--px-8);
	width: 100%;
	&:hover:not(:disabled),
	&:focus:not(:disabled) {
		background-color: var(--neutrals-00white);
		cursor: text;
	}
	&.isReadOnly {
		background-color: transparent;
		&:hover:not(:disabled),
		&:focus:not(:disabled) {
			background-color: transparent;
			cursor: auto;
		}
	}
	div {
		line-height: initial;
	}
	.single-line {
		height: var(--px-45);
	}
	.canvas-form-input-display-value {
		padding: var(--px-20) var(--px-12) var(--px-6) var(--px-6);
		line-height: unset;
		white-space: pre-line;
	}
`;
